import axios from 'axios'
import { Link } from 'react-router-dom'
import Price from '../../ui/price'
import { ReceiverInfo } from './ReceiverInfo'
import { DiscountBreakdown } from './DiscountBreakdown'
import { Helmet } from 'react-helmet-async'
import { API_BASE_URL } from 'config/api'
import { OrderNoteForm } from './OrderNote'

export const Payment = () => {
  const items = localStorage.getItem('cart')
  const cart = items ? JSON.parse(items) : ''
  let url = `${API_BASE_URL}/orders/${cart.id}/payment-url`
  const redirectToPaymentUrl = async () => {
    await axios.get(url).then((res) => {
      window.location.href = res.data
    })
  }

  return (
    <div className='container mx-auto my-10 h-auto border p-4 rounded-md' style={{ backgroundColor: 'var(--card-bg)', color: 'var(--text-primary)', borderColor: 'var(--border-color)' }}>
      <Helmet>
        <title className='text-xl font-semibold font-semibold'>
          اطلاعات پرداخت
        </title>
        <meta
          name='description'
          content='بوک استوری - هر کتاب یک داستان، هر داستان یک زندگی دوباره'
        />
      </Helmet>
      <h2 className='section-header mb-8 border-b-2 pb-2 text-2xl font-semibold font-semibold'>
        سفارش آماده پرداخت
      </h2>
      <section>
        <p className='mb-4 text-lg'>
          سفارش شما آماده‌ی پرداخت آنلاین با استفاده از کارت‌های بانکی عضو شتاب
          است. لطفا اطلاعات خرید خود را بار دیگر مطالعه کنید و سپس دکمه‌ی پرداخت
          آنلاین را فشار دهید. توجه داشته باشید که سفارش‌ها تنها پس از پرداخت
          موفق، ثبت نهایی می‌شوند.
        </p>
      </section>

      <section>
        <div className='shipping-address'>
          <ReceiverInfo order={cart} />
        </div>
      </section>

      {/* Display applied discounts if any */}
      {cart?.appliedDiscounts && cart.appliedDiscounts.length > 0 && (
        <section className='my-6'>
          <DiscountBreakdown
            appliedDiscounts={cart.appliedDiscounts}
            totalDiscountAmount={cart.totalDiscountAmount || 0}
            currency={cart.priceCurrency}
            allowRemoval={false}
          />
        </section>
      )}

      <section>
        <h3 className='my-6'>
          <strong className='ml-3'>مبلغ قابل پرداخت:</strong>
          <Price
            value={cart?.total}
            currencyCode={cart.priceCurrency}
            alternativeCurrencyCode={true}
          />
        </h3>

        <OrderNoteForm cart={cart} />
        <div className='flex items-center w-full flex-col md:flex-row lg:w-1/2 mt-12 mb-8 justify-between gap-4'>
          <button
            onClick={() => redirectToPaymentUrl()}
            className='p-3 rounded flex items-center justify-center text-white w-full md:w-1/2 text-lg font-semibold font-semibold'
            style={{ backgroundColor: 'var(--accent-primary)' }}
          >
            پرداخت آنلاین
          </button>
          <Link
            className='border p-3 rounded flex items-center justify-center w-full md:w-1/2 text-lg font-semibold font-semibold'
            style={{ backgroundColor: 'var(--bg-primary)', borderColor: 'var(--accent-primary)', color: 'var(--accent-primary)' }}
            to='/cart'
          >
            تغییر در سفارش
          </Link>
        </div>
      </section>
    </div>
  )
}
